import * as Utilities from '../utilities'

export default {
    name: 'da',
    messages: {
        min_dimensions: (field, [width, height]) => `${field} skal mindst være ${width} pixels gange ${height} pixels.`,
        max_dimensions: (field, [width, height]) => `${field} skal maksimalt være ${width} pixels gange ${height} pixels.`,
        min_size: (field, [size]) => `${field} skal være mindst ${Utilities.formatFileSize(size)} stort.`,
    }
};